export default __webpack_public_path__ + "static/media/12.99b303fb.jpg";